import React, { useState } from 'react';
import {
  ShieldCheck,
  Truck,
  Users,
  TrendingUp,
  FileText,
  CalendarDays,
  Target,
  BadgeCheck,
  X,
  Hash
} from 'lucide-react';
import './QualityCertification.css';

const QualityCertification = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <section className="quality-cert-section">
      <div className="quality-cert-container">
        <div className="quality-cert-content">
          <div className="quality-pill">
            <ShieldCheck size={18} />
            <span>Quality Assurance & Certification</span>
          </div>

          <h2 className="quality-title">
            Certified for Quality.<br />
            <span className="text-highlight">Trusted for Innovation.</span>
          </h2>

          <p className="quality-description">
            ITSOFTLAB Consultancy Services Private Limited is proudly <strong style={{ color: '#1e3a8a' }}>ISO 9001:2015</strong> certified for its Quality Management System. This certification reflects our unwavering commitment to quality, consistency, customer satisfaction, and continuous improvement across every solution we deliver.
          </p>

          <div className="quality-features">
            <div className="q-feature">
              <div className="q-icon-wrapper">
                <ShieldCheck size={24} />
              </div>
              <div className="q-feature-text">
                <h3>Quality Management System</h3>
                <p>Structured processes that ensure consistency, compliance, and exceptional quality.</p>
              </div>
            </div>

            <div className="q-feature">
              <div className="q-icon-wrapper">
                <Truck size={24} />
              </div>
              <div className="q-feature-text">
                <h3>Reliable Delivery Processes</h3>
                <p>Proven methodologies and disciplined execution for on-time, high-quality delivery.</p>
              </div>
            </div>

            <div className="q-feature">
              <div className="q-icon-wrapper">
                <Users size={24} />
              </div>
              <div className="q-feature-text">
                <h3>Customer-Centric Excellence</h3>
                <p>Focused on delivering solutions that create value and exceed customer expectations.</p>
              </div>
            </div>

            <div className="q-feature">
              <div className="q-icon-wrapper">
                <TrendingUp size={24} />
              </div>
              <div className="q-feature-text">
                <h3>Continuous Improvement</h3>
                <p>We evaluate, evolve, and enhance our systems to drive sustainable growth and innovation.</p>
              </div>
            </div>
          </div>

          <button className="view-cert-btn" onClick={openModal}>
            <FileText size={20} />
            View Certificate
          </button>
        </div>

        <div className="quality-cert-visuals">

          <div className="podium-container">
            <div className="cert-frame">
              <div className="cert-image-placeholder">
                <img src="/iso-9001-2015-certificate.png" alt="ISO 9001:2015 Certificate Preview" className="cert-preview-img" onClick={openModal} />
              </div>
            </div>

            {/* 3D Podium base */}
            <div className="podium">
              <div className="podium-top"></div>
              <div className="podium-blue"></div>
              <div className="podium-base"></div>
            </div>
          </div>

          <div className="cert-info-cards">

            <div className="c-circle-badge">
              <BadgeCheck size={36} className="badge-icon" />
              <h4>ISO 9001:2015</h4>
              <p>Certified</p>
            </div>

            <div className="c-card c-date">
              <div className="c-card-icon"><CalendarDays size={20} /></div>
              <div className="c-card-text">
                <span className="c-label">Certified:</span>
                <span className="c-value">28 July 2026</span>
              </div>
            </div>

            <div className="c-card c-date">
              <div className="c-card-icon"><Hash size={20} /></div>
              <div className="c-card-text">
                <span className="c-label">Certificate Number:</span>
                <span className="c-value">305026072813Q</span>
              </div>
            </div>

            <div className="c-card c-scope">
              <div className="c-card-icon"><Target size={20} /></div>
              <div className="c-card-text">
                <span className="c-label">Scope:</span>
                <span className="c-value">IT Consulting, Software Development, SaaS, Cloud, AI Automation</span>
              </div>
            </div>

            <div className="laurel-text-container">
              <span className="laurel-branch left">(</span>
              <span className="laurel-text">ISO 9001:2015 Certified</span>
              <span className="laurel-branch right">)</span>
            </div>

          </div>
        </div>
      </div>

      <div className="quality-bottom-bar">
        {/* <div className="bottom-logo-container">
          <img src="/images/itsoftlab-logo.png" alt="ITSoftlab" className="bottom-logo" onError={(e) => { e.target.onerror = null; e.target.src="/images/logo.png" }} />
        </div> */}

        <div className="bottom-divider"></div>

        <div className="bottom-center-text">
          <ShieldCheck size={26} className="bottom-icon" />
          <span className="bottom-bold">Quality. Consistency. Customer Satisfaction.</span>
        </div>

        <div className="bottom-right-text">
          Our ISO 9001:2015 certification is a promise we uphold in every project, every day.
        </div>
      </div>

      {isModalOpen && (
        <div className="cert-modal-overlay" onClick={closeModal}>
          <div className="cert-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={closeModal}>
              <X size={24} />
            </button>
            <iframe
              src="/iso-9001-2015-certificate.pdf"
              title="ISO 9001:2015 Certificate"
              className="cert-iframe"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default QualityCertification;
